import { render, staticRenderFns } from "./warranty_check_detail_hotline.vue?vue&type=template&id=5dfc0f10&"
import script from "./warranty_check_detail_hotline.vue?vue&type=script&lang=js&"
export * from "./warranty_check_detail_hotline.vue?vue&type=script&lang=js&"
import style0 from "./warranty_check_detail_hotline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports